"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_final_form_1 = require("react-final-form");
const index_1 = require("../../components/index");
const SingleSelectField = ({ name, label, validate, options, InputProps, onClick, disabled, helperText, parse, format, }) => (react_1.default.createElement(react_final_form_1.Field, { name: name, validate: validate, parse: parse, format: format, onClick: onClick }, ({ input, meta }) => (react_1.default.createElement(index_1.Select, { textFieldProps: {
        label: label,
        error: meta.touched && meta.invalid,
        helperText: meta.touched && meta.error ? meta.error : helperText,
        InputProps: InputProps,
    }, ...input, options: options, value: options.find((option) => input.value === option.value), onChange: (option) => {
        // clearing the MUI select field passed option undefined
        // since we're using Option types and looking at option.value this gets
        // messed up unless we explicity pass null to the onChange
        if (!option) {
            input.onChange(null);
        }
        else {
            input.onChange(option.value);
        }
    }, disabled: disabled }))));
exports.default = SingleSelectField;
